import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { IAuthorizationState } from "interfaces/redux/reducers";

import { AUTHORIZATION_SLICE } from "./sliceNames";

const initialState: IAuthorizationState = {
  isAuthenticating: true,
  isAuthenticated: false,
  isSessionExpired: false,
  isWelcomed: false,
  isWelcoming: false,
  isShowTermsDataPrivacyModal: false,
};

interface IUpdateAuthorizationReducerPayload {
  isAuthenticating: boolean;
  isAuthenticated: boolean;
}

interface IUpdateAuthorizationExpiredSessionReducer {
  isSessionExpired: boolean;
}

interface IupdateWelcomeReducerPayload {
  isWelcomed: boolean;
  isWelcoming: boolean;
}

const authorizationSlice = createSlice({
  name: AUTHORIZATION_SLICE,
  initialState,
  reducers: {
    authorizeUser: state => {
      return {
        ...state,
        isAuthenticated: true,
        isAuthenticating: false,
      };
    },
    unauthorizeUser: state => {
      return {
        ...state,
        isAuthenticated: false,
        isAuthenticating: false,
      };
    },
    authenticatingUser: state => {
      return {
        ...state,
        isAuthenticated: false,
        isAuthenticating: true,
      };
    },
    welcomingUser: state => {
      return {
        ...state,
        isWelcomed: false,
        isWelcoming: true,
      };
    },
    welcomedUser: state => {
      return {
        ...state,
        isWelcomed: true,
        isWelcoming: false,
      };
    },
    unWelcomedUSer: state => {
      return {
        ...state,
        isWelcomed: false,
        isWelcoming: false,
      };
    },
    updateAuthorizationReducer: (state, action: PayloadAction<IUpdateAuthorizationReducerPayload>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateAuthorizationExpiredSessionReducer: (
      state,
      action: PayloadAction<IUpdateAuthorizationExpiredSessionReducer>,
    ) => {
      action.payload.isSessionExpired;
      return {
        ...state,
        isSessionExpired: !!action.payload.isSessionExpired,
      };
    },
    updateWelcomeReducer: (state, action: PayloadAction<IupdateWelcomeReducerPayload>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateShowTermsDataPrivacyUI: (
      state,
      action: PayloadAction<{
        isShowTermsDataPrivacyModal: boolean;
      }>,
    ) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetAuthorization: () => {
      return initialState;
    },
  },
});

export const {
  authorizeUser: actionAuthorizeUser,
  updateAuthorizationReducer: actionUpdateAuthorizationReducer,
  unauthorizeUser: actionUnauthorizeUser,
  resetAuthorization: actionResetAuthorization,
  authenticatingUser: actionAuthenticatingUser,
  updateAuthorizationExpiredSessionReducer: actionUpdateAuthorizationExpiredSessionReducer,
  welcomedUser: actionWelcomedUser,
  welcomingUser: actionWelcomingUser,
  unWelcomedUSer: actionUnWelcoming,
  updateWelcomeReducer: actionUpdateWelcomeReducer,
  updateShowTermsDataPrivacyUI: actionUpdateShowTermsDataPrivacyUI,
} = authorizationSlice.actions;

export default authorizationSlice.reducer;
